<template>
  <div class="soundscape species-soundscape">
    <Spectrogram ref="spectrogram" :url="soundscape.url" :startTime="soundscape.startTime" :endTime="soundscape.endTime" :height="0" @loaded="loading = false"/>

    <div class="species-soundscape-station">
      <img :src="stationIconUrl(detection.station.type)" class="station-icon" />
      {{ detection.station.name }}
    </div>

    <div class="species-soundscape-detail">
      <time class="timestamp">
        {{ formatDate(detection.timestamp) }}
        <small class="text-muted">{{ formatTime(detection.timestamp) }}</small>
      </time>

      <DetectionScore class="inline" :detection="detection" tooltipPlacement="left" />
    </div>
  </div>
</template>

<script>
import DetectionScore from 'components/DetectionScore'
import Spectrogram from 'components/Spectrogram'

import { stationIcon } from 'lib/station'

export default {
  props: {
    soundscape: {
      type: Object,
      required: true
    },

    detection: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: true
    }
  },

  methods: {
    stationIcon,

    stationIconUrl (type) {
      return require(`images/markers/${this.stationIcon(type)}-2x.png`)
    },
  },

  computed: {
    defaultDateFormat () {
      return 'Do MMMM YYYY'
    },

    defaultTimeFormat () {
      if (this.timeFormat == '24h') {
        return 'HH:mm:ss'
      } else {
        return 'h:mm:ss A'
      }
    }
  },

  components: {
    DetectionScore,
    Spectrogram
  }
}
</script>
